import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { FluidsInfusionActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-fluids-infusion-slot-v2',
    templateUrl: './fluids-infusion-slot-v2.component.html',
    styleUrl: './fluids-infusion-slot-v2.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FluidsInfusionSlotComponentV2 implements SheetSlotComponentBase {

	action!: FluidsInfusionActionV2;
	value!: string | null;

	@Input('action') set updateAction(action: FluidsInfusionActionV2 | null) {
		this.action = action as FluidsInfusionActionV2;
		this.value = this.action.rate?.value?.toString() ?? null;
	}

	constructor() {
	}
}